import s from './Select.module.scss';

type SelectProps<V> = {
  name: string;
  label?: string;
  value: V;
  setValue: (value: V) => void;
  data: { value: V; label: string; disabled?: boolean }[];
  disabled?: boolean;
};
export const Select = <V extends string | number | null>({
  name,
  label,
  value,
  setValue,
  data,
  disabled,
}: SelectProps<V>) => {
  const onSelect = (event: React.ChangeEvent<HTMLSelectElement>) => {
    if (setValue) setValue(event.target.value as unknown as V);
  };

  const fakeDefault =
    data.find(d => d.value === value) && value ? value : '_blank';

  return (
    <div className={s.select__wrapper}>
      {label && (
        <label htmlFor={name} className={s.select__label}>
          {label}
        </label>
      )}
      <div className={s.select__chevron}>
        <select
          className={s.select}
          name={name}
          id={name}
          onChange={onSelect}
          value={fakeDefault}
          disabled={disabled}>
          {[{ value: '_blank', label: '', disabled: true }, ...data].map(
            item => (
              <option
                key={`option-${item.value}`}
                className={s.select__option}
                value={item.value ?? undefined}
                disabled={item.disabled}>
                {item.label}
              </option>
            ),
          )}
        </select>
      </div>
    </div>
  );
};
